import React from "react"
import style from "./swirl.mod.scss"
import SwirlSvg from "@svgs/swirl.svg"
import TopTextureSvg from "@svgs/top-texture.svg"
import Blob from "@svgs/video-blob.svg"

const Swirl = ({ blob, sauna, modifiers = [] }) => {
  blob && modifiers.push(`${style.swirl}--blob`)
  sauna && modifiers.push(`${style.swirl}--sauna`)
  return (
    <div className={[style.swirl, ...modifiers].join(" ")}>
      {blob ? <Blob /> : sauna ? <TopTextureSvg /> : <SwirlSvg />}
    </div>
  )
}

export default Swirl
